module.exports = __webpack_public_path__ + "static/media/logo.3bfe2e25.png";